import type {
  HubOneOfResourceMetadata,
  HubResource,
  HubResourceKind,
} from '@robovision/hub'
import type { JobV2 } from '../jobV2/Job'


export interface ModelResourceParams extends HubResource {
  sourceJob?: JobV2
}

export class ModelResource implements HubResource {
  public readonly artifactId?: string
  public readonly checksum: string
  public readonly createdAt: string
  public readonly definitionId: string
  public readonly description: string
  public readonly filename: string
  public readonly id: string
  public readonly kind: HubResourceKind
  public readonly lastUpdatedAt: string
  public readonly metadata: HubOneOfResourceMetadata
  public readonly projectId: string
  public readonly resourceName: string
  public readonly sourceJob?: JobV2
  public readonly sourceJobId?: string
  public readonly valid: boolean

  constructor (params: ModelResourceParams) {
    this.artifactId = params.artifactId
    this.checksum = params.checksum
    this.createdAt = params.createdAt
    this.definitionId = params.definitionId
    this.description = params.description
    this.filename = params.filename
    this.id = params.id
    this.kind = params.kind
    this.lastUpdatedAt = params.lastUpdatedAt
    this.metadata = params.metadata
    this.projectId = params.projectId
    this.resourceName = params.name
    this.sourceJob = params.sourceJob
    this.sourceJobId = params.sourceJobId
    this.valid = params.valid
  }

  get name () {
    return this.resourceName ??
      this.sourceJob?.name ??
      this.metadata?.name as string ??
      this.id
  }

  /**
   * Version of the algorithm that created this resource.
   * May be undefined for models created before 5.12.
   */
  get algorithmVersion (): string | undefined {
    return this.metadata?.algorithmVersion
  }
}
